import axios from 'axios'
import { isNil } from 'lodash'
import { ERROR_TYPE } from './ErrorType'
import { MediaUsedOnDeletionError } from './MediaUsedOnDeletionError'
import { NotFoundError } from './NotFoundError'


export const handleError = response => {
  if (response?.data?.error) {
    const { error } = response.data
    switch (error.type) {
      case ERROR_TYPE.USED_IN_PROJECTS: {
        return response
      }
      case ERROR_TYPE.FOLDER_NOT_EMPTY: {
        const { title, message } = error
        throw new MediaUsedOnDeletionError({ title, message, type: error.type })
      }
      case ERROR_TYPE.NOT_FOUND: {
        const { message } = error
        throw new NotFoundError(message)
      }
      default: {
        console.error('Unknown error handled:', error)
        throw error
      }
    }
  }

  if (response?.data?.status?.errors?.length) {
    const commonErrorString = response.data.status.errors.map(error => JSON.stringify(error))
    throw new Error(commonErrorString)
  }
  return response
}

export const isCancelledReq = (error, abortController) => {
  if (!isNil(abortController) && abortController?.signal?.aborted) {
    return true
  }
  return error.code === 'ERR_CANCELED'
      || error.name === 'CanceledError'
      || error.name === 'AbortError'
      || axios.isCancel(error)
}

const NETWORK_ERROR_CODES = new Set([
  'ERR_NETWORK',
  'ERR_INTERNET_DISCONNECTED',
  'ERR_NAME_NOT_RESOLVED',
  'ECONNABORTED',
  'ECONNREFUSED',
  'ECONNRESET',
  'ETIMEDOUT',
  'ENETUNREACH',
  'EPIPE',
])

export const isNetworkError = e => {
  if (!e?.response && e?.message === 'Network Error' && e?.request) return true
  const code = e?.code
  return !!code && NETWORK_ERROR_CODES.has(code)
}
